import { Flex, FlexProps } from '@mantine/core';
import styled from 'styled-components';

export const StatusScreen = styled(Flex)<FlexProps>`
	flex: 1;
`;

export const BodyRow = styled(Flex)<FlexProps>`
	flex: 1;
	min-height: 0;
	overflow: hidden;
	padding: 0 1.5rem 1.5rem;
	gap: 1rem;
`;

export const PdfCard = styled(Flex)<FlexProps>`
	flex: 1 1 auto;
	min-width: 0;
	overflow: auto;
	border: 1.5px solid ${({ theme }) => theme.v3.colors.gray[2]};
	border-radius: 10px;
	background-color: ${({ theme }) => theme.v3.colors.white[5]};
`;

export const SigningPanelCard = styled.div`
	flex: 0 0 380px;
	overflow-y: auto;
	border: 1.5px solid ${({ theme }) => theme.v3.colors.gray[2]};
	border-radius: 10px;
	background-color: ${({ theme }) => theme.v3.colors.white[5]};
`;

export const SuccessCard = styled.div`
	width: 100%;
	max-width: 420px;
	overflow: hidden;
	border: 1.5px solid ${({ theme }) => theme.v3.colors.gray[2]};
	border-radius: 10px;
	background-color: ${({ theme }) => theme.v3.colors.white[5]};
`;
